import PropTypes from 'prop-types';
import {ButtonWithIcon} from '@/components/atoms';
import {Accordion} from '@/components/molecules/Accordion';
import {AccordionItem} from '@/components/molecules/AccordionItem';
import {
  PerfectStoreSetupReview,
  PerfectStoreDisplayReview
} from '@/containers/PerfectStore/PerfectStoreReview';
import '@/containers/ReviewAccordion/reviewAccordion.scss';
import '@/containers/PerfectStore/PerfectStoreReview/perfectStoreReview.scss';
import './perfectStorePreview.scss';

const EditSectionButton = ({step, onEdit}) => (
  <ButtonWithIcon
    iconLeading='edit'
    handleButton={(event) => {
      event?.stopPropagation();
      onEdit(step);
    }}
    uiSchema={{
      title: 'Edit Section',
      variant: 'tertiary',
      size: 'small',
      isDark: true
    }}
  />
);

EditSectionButton.propTypes = {
  step: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired
};

const PerfectStoreRequirementsPanels = ({
  formData,
  languages = [],
  isEditable = false,
  onEdit
}) => (
  <div
    className='perfect-store-requirements-panels sales-target-review perfect-store-review mt-2 flex w-full flex-col gap-4'
    data-testid='perfect-store-requirements-panels'>
    <Accordion
      isDark
      content={
        <AccordionItem
          isDark
          expanded
          label='Setup'
          rightAccessoryChild={
            isEditable ? <EditSectionButton step={1} onEdit={onEdit} /> : null
          }
          content={<PerfectStoreSetupReview formData={formData} />}
        />
      }
    />
    <Accordion
      isDark
      content={
        <AccordionItem
          isDark
          expanded
          label='Display'
          rightAccessoryChild={
            isEditable ? <EditSectionButton step={2} onEdit={onEdit} /> : null
          }
          content={
            <PerfectStoreDisplayReview
              formData={formData}
              languages={languages}
            />
          }
        />
      }
    />
  </div>
);

PerfectStoreRequirementsPanels.propTypes = {
  formData: PropTypes.object,
  languages: PropTypes.array,
  isEditable: PropTypes.bool,
  onEdit: PropTypes.func.isRequired
};

export default PerfectStoreRequirementsPanels;
